
import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";

import { Routes, Route, Navigate, Link, useLocation } from "react-router-dom";

import { loginRequest } from "config/authConfig";
import { apiConfig } from 'config/apiConfig'

import useFetchWithMsal from 'hooks/useFetchWithMsal';

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftAvatar from "components/SoftAvatar";

import SoftTypography from "components/SoftTypography";
import MiniActionCard from "components/Elements/MiniActionCard";

import wavesWhite from "assets/images/shapes/waves-white.svg";

import { ProgressIndicator, useProgressIndicator } from 'components/Elements/ProgressIndicator';

import { useDialog } from "components/Elements/Dialog/common";

// Soft UI Dashboard PRO React components

import { StaffEditorDialog } from "./components/StaffEditor";
import StaffGames from './components/StaffGames';


const StaffDetails = ({ cardroom, id }) => {

    const [staff, setStaff] = useState(null)

    const [retryCounter, setRetryCounter] = useState(0);

    function handleRetry() {
        setRetryCounter(retryCounter + 1);
    }
    const [showProgress, progressIndicatorProps] = useProgressIndicator("wait", "Loading staff details...", handleRetry)

    const [openStaffEditorDialog, openStaffEditorDialogProps] = useDialog();


    const { error, execute } = useFetchWithMsal({
        scopes: apiConfig.people.scopes.read,
    });

    const accountRequest = useFetchWithMsal({
        scopes: apiConfig.account.scopes.read,
    });

    //load cardroom players
    useEffect(() => {
        if (!staff) {

            progressIndicatorProps.setMode("wait");
            progressIndicatorProps.setMessage("Loading staff details...")
            showProgress();

            execute("GET", apiConfig.people.endpoint + "/venue/" + cardroom.id + "/participants/" + id).then((response) => {
                if (response) {
                    //build formatted player object

                    var p = {};
                    p = Object.assign(p, response);

                    let name = p.properties && p.properties.name ? p.properties.name : p.name;
                    let nickName = p.properties ? p.properties.nickName : null;
                    if (nickName) {
                        name += " \"" + nickName + "\"";
                    }

                    p.formattedName = name;

                    let phone = p.properties && p.properties.phoneNumber ? p.properties.phoneNumber : p.phoneNumber;
                    if (phone && phone.length === 10) {
                        phone = "+1 (" + phone.substring(0, 3) + ") " + phone.substring(3, 6) + "-****";
                    }
                    p.formattedPhone = phone;

                    //net to get balance info from accounting service...
                    if (p) {

                        progressIndicatorProps.setMode("wait");
                        progressIndicatorProps.setMessage("Loading staff account...");
                        // [HttpGet("{entityId:Guid}/holders/{holderId:Guid}/accounts/{type:int}", Name = "GetEntityAccount")]
                        accountRequest.execute("GET", apiConfig.account.endpoint + "/" + cardroom.id + "/holders/" + p.id + "/accounts/1").then((accnt) => {
                            if (accnt) {
                                p.account = accnt;
                            }
                            progressIndicatorProps.close();
                        }).catch((ex) => {
                            progressIndicatorProps.setMode("errorWithRetry");
                            progressIndicatorProps.setMessage("Unable to load staff account, please try again...")
                        });
                    }

                    setStaff(p);

                    progressIndicatorProps.close();
                }
            }).catch((ex) => {
                progressIndicatorProps.setMode("errorWithRetry");
                progressIndicatorProps.setMessage("Unable to load staff details, please try again...")
            });
        }
    }, [execute, staff, retryCounter]) //cardroomListData 


    return (<>
        <ProgressIndicator {...progressIndicatorProps} />
        {!progressIndicatorProps.visible ? <>

            <SoftBox mb={3} p={1}>
                <SoftBox
                    position="relative"
                    bgColor="secondary"
                    py={3}
                    px={{ xs: 3, sm: 6, md: 1 }}
                    mt={3}
                    borderRadius="xl"
                    variant="gradient"
                >

                    <SoftBox
                        component="img"
                        src={wavesWhite}
                        alt="pattern-line"
                        width="100%"
                        position="absolute"
                        left="0"
                        top="0"
                        opacity={0.4}
                    />

                    <Grid container alignItems="center" position="relative">
                        <Grid item xs={12} lg={1}>
                            <SoftBox textAlign="center" >
                                <SoftAvatar variant="rounded"
                                    bgColor="dark"
                                    src={staff ? (staff.properties && (staff.properties.hasPhoto || staff.hasPhoto) ? apiConfig.images.endpoint + "/player/" + staff.id + ".jpg" : staff.name.substring(0, 1)) : "G"}
                                    alt={staff ? (staff.properties && staff.properties.name ? staff.properties.name : staff.name) : ""}
                                    display="flex"
                                    size="xl"
                                    style={{ marginLeft: "auto", "marginRight": "auto" }} />
                            </SoftBox>
                        </Grid>
                        <Grid item xs={12} lg={11}>
                            <Grid container>
                                <Grid item xs={6} lg={3} p={1}>
                                    <MiniActionCard
                                        bgColor="dark"
                                        title={{ text: "name", fontWeight: "medium" }}
                                        count={{ text: staff ? staff.formattedName : "" }}
                                        icon={{ component: "person" }}
                                        action={openStaffEditorDialog}
                                    />
                                </Grid>
                                <Grid item xs={6} lg={3} p={1}>
                                    <MiniActionCard
                                        bgColor="dark"
                                        title={{ text: "phone", fontWeight: "medium" }}
                                        count={{ text: staff ? staff.formattedPhone : "" }}
                                        icon={{ component: "phone" }}
                                        action={openStaffEditorDialog}
                                    />

                                </Grid>
                                <Grid item xs={6} lg={3} p={1}>
                                    <MiniActionCard
                                        bgColor="dark"
                                        title={{ text: "withholding rate", fontWeight: "medium" }}
                                        count={{ text: staff && staff.properties ? staff.properties.withholdingRate * 100 : 0, suffix: "%", useNumberFormatter: false }}
                                        percentage = {{text: "%", color: "white"}}
                                        icon={{ component: "credit_card" }}
                                        action={openStaffEditorDialog}
                                    />

                                </Grid>

                                <Grid item xs={6} lg={3} p={1}>
                                    <MiniActionCard
                                        bgColor="dark"
                                        title={{ text: "balance", fontWeight: "medium" }}
                                        count={{ text: staff && staff.account ? staff.account.accountsPayable - staff.account.accountsReceivable : 0, prefix: "$", useNumberFormatter: true, color: "error" }}
                                        icon={{ color: "info", component: "paid" }}
                                    />
                                </Grid>
                            </Grid>

                            <StaffEditorDialog {...openStaffEditorDialogProps} cardroom={cardroom} staff={staff} />
                        </Grid>

                    </Grid>
                </SoftBox>
            </SoftBox>


            <SoftBox mb={3} p={1}>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={12} lg={12} sx={{ ml: "auto", mr: "auto" }}>
                        <SoftBox>
                            {staff ?
                                <StaffGames cardroom={cardroom} staff={staff} /> : null}
                        </SoftBox>
                    </Grid>
                </Grid>
            </SoftBox>
        </> : null}
    </>);

};

StaffDetails.defaultProps = {

};

StaffDetails.propTypes = {
    cardroom: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
};


export default StaffDetails;